const mdf = 1;
const bu = 2;
const own = 3;
const extra = 4;

export default {
  mdf,
  bu,
  own,
  extra
};
